import { render, staticRenderFns } from "./waitForDistribution.vue?vue&type=template&id=61545fcd&scoped=true&"
import script from "./waitForDistribution.vue?vue&type=script&lang=js&"
export * from "./waitForDistribution.vue?vue&type=script&lang=js&"
import style0 from "./waitForDistribution.vue?vue&type=style&index=0&id=61545fcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61545fcd",
  null
  
)

export default component.exports